
import { TheCreateProfileSelection, TheAboutStep } from "./components";
import {
  TheIdentifier,
  TheCode,
  TheEmail,
  ThePassword,
  Welcome,
  TheConsent,
} from "../../../Common/CommonSteps";
import AppSvc from "../../../../services/app-svc";
import { AppEventbus } from "../../../../services/app-svc";

let service = null;

export default {
  name: "create-profile",
  components: {
    TheCreateProfileSelection,
    TheAboutStep,
    TheIdentifier,
    TheCode,
    TheEmail,
    ThePassword,
    Welcome,
    TheConsent,
  },
  props: {
    apiUrl: {
      required: true,
      default: "",
    },
    user: {
      required: false,
      default: null,
    },
    salons: {
      required: false,
      default: [],
    },
    isTpn: {
      type: Boolean,
      required: true,
    },
    tpnChainId: {
      type: Number,
      required: true,
    },
    tpnSiteId: {
      type: Number,
      required: true,
    },
    useAxios: Boolean,
    oauthUrl: {
      Type: String,
      required: true,
    },
    layout: {
      type: String,
      default: "chain",
      required: false,
    },
    initialCreateStep: {
      type: String,
      default: "create-profile-selection",
      required: false,
    },

    isProfile: {
      required: false,
      default: false,
      type: Boolean,
    },
    oauthData: {
      required: false,
      default: null,
    }
  },
  data() {
    return {
      state: {
        SELECTION: "create-profile-selection",
        EMAIL_REGISTRATION: "insert-email",
        EMAIL_CODE: "verify-email",
        ABOUT: "insert-userdata",
        SMS_CODE: "verify-sms",
        PASSWORD: "create-password",
        CONSENT: "consent",
        WELCOME: "welcome-screen",
      },
      currentForm: "create-profile-selection",
      loading: false,
      tempUser: null,
      error: "",
      showResendText: false,
      params: {
        username: "",
        password: "",
        mobile: "",
        firstName: "",
        lastName: "",
        code: "",
        ecode: "",
        step: "",
        isTpn: "",
        tpnChainId: "",
        tpnSiteId: "",
        clientIdentity: "",
        eclientIdentity: "",
      },
    };
  },
  computed: {
    coreApiUrl() {
      return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_CORE_API_URL : this.$config.FIXIT_CORE_API_URL
    },
  },
  beforeDestroy() {
    AppEventbus.$off("create-new-oauth-user");
  },
  methods: {
    changeView(state) {
      this.resetError();
      this.$emit("changeView", state);
    },
    previousStep() {
      this.resetError();
      this.currentForm = "create-profile-selection";
    },
    verifyInputFields() {
      switch (this.currentForm) {
        case "insert-email":
          return this.params["username"] == "";
        case "insert-userdata":
          return (
            this.params["firstName"] == "" ||
            this.params["lastName"] == "" ||
            this.params["mobile"] == ""
          );
        case "create-password":
          return this.params["password"] == "";
        default:
          return false;
      }
    },
    resetError() {
      this.error = "";
    },
    /**
     * PARAMETER SETTERS
     */
    setEmailCode(value) {
      this.error = "";
      this.params["ecode"] = value;
    },
    setMobileCode(value) {
      this.error = "";
      this.params["code"] = value;
    },
    setUserData(value) {
      this.error = "";
      this.params["firstName"] = value.firstName;
      this.params["lastName"] = value.lastName;
      this.params["mobile"] = value.mobile;
    },
    setClientIdentity(value) {
      this.params["clientIdentity"] = value;
    },
    setEClientIdentity(value) {
      this.params["eclientIdentity"] = value;
    },
    setUsername(value) {
      this.error = "";
      this.params["username"] = value;
    },
    setPassword(value) {
      this.params["password"] = value;
    },

    startEmailVerification(value) {
      if (value.data?.nextStep === this.state.EMAIL_CODE) {
        this.setUsername(value.data.fixitNoUser.email);
        this.email = value.data.fixitNoUser.email;
        this.setEClientIdentity(value.data.clientIdentity);
        this.currentForm = value.data.nextStep;
      } else if (
        (value.data?.nextStep == null ||
          value.data?.nextStep === this.state.WELCOME) &&
        value.data.fixitNoUser != null
      ) {
        this.currentForm = value.data.nextStep;

        this.$emit("setUser", value.data.fixitNoUser);
      }
    },
    resendCode() {
      var body = {
        username: this.params.username,
        isTpn: this.isTpn.toString(),
        tpnChainId: this.tpnChainId.toString(),
        tpnSiteId: this.tpnSiteId.toString(),
        step:
          this.currentForm == "verify-email"
            ? "insert-email"
            : "insert-userdata",
        email: this.email,
        mobile: this.params.mobile,
        resendCode: 'true'
      };

      service
        .verifySignupStep(
          `${process.env.VUE_APP_FIXIT_CORE_API_URL}/api`,
          body
        )
        .then((response) => {
          this.error = "";
          if (response.data.responseCode === 200) {
            this.showResendText = true;
            var result = response.data;
            this.clientIdentity = result.clientIdentity;
          } else {
            this.error = response.data.responseMessage;
          }
        });
    },
    async VerifyStep() {
      this.loading = true;
      this.error = "";
      try {
        if (
          [this.state.SMS_CODE, this.state.EMAIL_CODE].includes(
            this.currentForm
          ) ||
          this.$refs.validation.validate()
        ) {
          Object.assign(this.params, { step: this.currentForm });
          let response = await service.verifySignupStep(
            `${this.coreApiUrl}/api`,
            this.params
          );
          if (response.data.responseCode == 200) {
            if (this.params.customerId && response.data.fixitNoUser != null) {
              var userData = {
                firstName: response.data.fixitNoUser.firstName.trim(),
                lastName: response.data.fixitNoUser.lastName.trim(),
                mobile: response.data.fixitNoUser.mobileNumber.trim(),
              };
              this.tempUser = userData;
            }
            response.data.nextStep == "verify-email"
              ? this.setEClientIdentity(response.data.clientIdentity)
              : response.data.nextStep == "verify-sms"
                ? this.setClientIdentity(response.data.clientIdentity)
                : "";

            this.currentForm = response.data.nextStep;
            if (response.data.nextStep === "welcome-screen") {
              this.$emit("setUser", response.data.fixitNoUser);
            }
          } else {
            this.showResendText = false;
            this.error = response.data.responseMessage;
          }
        }
      } catch (error) {
        console.log("Verifying step failed: " + error);
      }
      this.loading = false;
    },
    close() {
      this.$emit("close");
    },
  },
  async created() {
    service = await AppSvc(this.useAxios ? this.$axios : null);
    Object.assign(this.params, {
      isTpn: this.isTpn.toString(),
      tpnChainId: this.tpnChainId.toString(),
      tpnSiteId: this.tpnSiteId.toString(),
    });
    if (
      this.$route.query.action &&
      this.$route.query.siteId &&
      this.$route.query.customerId
    ) {
      Object.assign(this.params, {
        siteId: this.$route.query.siteId,
        customerId: this.$route.query.customerId,
      });
    }
  },
};
